import Page from "./Login";

export default Page;
